module.exports = __webpack_public_path__ + "static/media/personal-values-large@2x.60bab971.png";